import { render, staticRenderFns } from "./BasicSalaryDialog.vue?vue&type=template&id=2153e3a7&scoped=true"
import script from "./BasicSalaryDialog.vue?vue&type=script&lang=js"
export * from "./BasicSalaryDialog.vue?vue&type=script&lang=js"
import style0 from "./BasicSalaryDialog.vue?vue&type=style&index=0&id=2153e3a7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2153e3a7",
  null
  
)

export default component.exports